module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"male":"Male","female":"Female"},"es":{"male":"Hombre","female":"Mujer"},"sw":{"male":"Mwanaume","female":"Mwanamke"}}')
  delete Component.options._Ctor
}
